var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusCheckmarkCircleSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10Z",
    fill: "#57A635"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 14.55C7.86839 14.5508 7.73793 14.5256 7.61609 14.4758C7.49426 14.426 7.38344 14.3527 7.29 14.26L4.34 11.26C4.15302 11.0717 4.04851 10.8169 4.04944 10.5515C4.05038 10.2861 4.1567 10.032 4.345 9.84503C4.5333 9.65805 4.78817 9.55354 5.05354 9.55448C5.3189 9.55541 5.57302 9.66173 5.76 9.85003L8 12.07L13.24 5.87003C13.4111 5.66714 13.6557 5.54052 13.9201 5.51801C14.1846 5.49551 14.4471 5.57897 14.65 5.75003C14.8529 5.9211 14.9795 6.16575 15.002 6.43018C15.0245 6.6946 14.9411 6.95714 14.77 7.16003L8.82 14.16C8.72944 14.266 8.61772 14.3519 8.492 14.4122C8.36629 14.4725 8.22936 14.5058 8.09 14.51L8 14.55Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusCheckmarkCircleSolid);
export default __webpack_public_path__ + "static/media/status-checkmark-circle-solid.a346976d3a86a4e62d00085ead5185de.svg";
export { ForwardRef as ReactComponent };